import {Component, Input, OnInit} from "@angular/core";


@Component({
	selector:'sa-status',
	standalone:true,
	template:`
        <span class="badge-sa badge {{cssClass}}" title="{{message}}">{{status}}</span>
    `,
	styles:[`
        .badge-sa{font-size: 14px; margin-right: 3px;}
    `]
})
export class SAStatusBadge implements OnInit{
	
	@Input()
	status:string|undefined = "S1";
	
	message:string = "";
	
	cssClass:string = "";
	
	
	saStatus:Array<{code:string,description:string}> = [
		{code:"S1", description:"Bill on File"},
		{code:"S2", description:"No Bill Match (Not on File)"},
		{code:"S3", description:"No Bill Match (Not on File)"},
		{code:"S4", description:"No Bill Match (Not on File)"},
		{code:"S5", description:"No Bill Match (Not on File)"},
		{code:"S6", description:"No Bill Match (Wrong Type)"},
		{code:"S7", description:"Duplicate ISF by Another Filer"},
		{code:"SA", description:"No Bill Match (Wrong Type)"},
		{code:"SB", description:"No Bill Match (Wrong Type)"},
		{code:"SC", description:"No Bill Match (Wrong Type)"}
	];
	
	ngOnInit(): void {
		
		if(!this.status){return}
		
		if(this.status !== null){
			
			// @ts-ignore
			this.message = this.saStatus.find((sa) => sa.code == this.status)?.description;
			
			if(this.status == "S1"){
				this.cssClass = "badge-success bg-success";
			}
			
			if(["S2","S3","S4","S5","S6"].includes(this.status)){
				this.cssClass = "badge-warning bg-warning text-black";
			}
			
			if(["S7","SA","SB","SC"].includes(this.status)){
				this.cssClass = "badge-danger bg-danger";
			}
		}
	}
	
	
}
